
































import {
  defineComponent,
  ref,
  reactive,
  computed,
  onUnmounted,
  onMounted,
  getCurrentInstance,
} from '@vue/composition-api';
import { FormRule } from 'tdesign-vue';
import Modal from '@/renderer/components/mobile/base/Modal/index.vue';
import Cell from '@/renderer/components/mobile/base/Cell/index.vue';
import EidtModal from '@/renderer/components/mobile/EidtModal/index.vue';
import SelectActionSheet from '@/renderer/components/mobile/SelectActionSheet/index.vue';
import i18n, { i18n_t } from '@/locales/i18n';
import {
  BUSINESS_OPTIONS,
  SCALE_OPTIONS,
  POSITION_OPTIONS,
} from '@/renderer/scripts/utils/ConstantConfig/ConstantI18NConfig';
import tips from '@/renderer/scripts/utils/tips';
import ipc from '@/renderer/scripts/utils/ipc';
import smh from '@/renderer/scripts/smh';
type IOptions = Array<{
  label: string;
  value: string;
}>;
export default defineComponent({
  name: 'MobileUserSurvey',
  components: {
    Modal,
    Cell,
    EidtModal,
    SelectActionSheet,
  },
  setup() {
    const innerShow = ref(false);
    const showEditModal = ref(false);
    const showSelectSheet = ref(false);
    const currSelectValue = ref(''); // 用户select选择的值
    const rules = ref<
      Array<
        FormRule & {
          whitespace?: boolean;
        }
      >
    >([]); // 表单验证规则
    const options = ref<IOptions>([]);
    const businessOpitons = ref<IOptions>(BUSINESS_OPTIONS);
    const positionOptions = ref<IOptions>(POSITION_OPTIONS);
    const sheetTitle = ref('');
    const eidtTitle = ref('');
    const surveyInfo = reactive({
      business: '',
      orgName: '',
      role: '',
      scale: '',
    });
    const showCustomAdd = computed(() => {
      return [i18n_t('您的职位'), i18n_t('所属行业')].includes(sheetTitle.value);
    });
    const canSubmit = computed(() => {
      const { business, orgName } = surveyInfo;
      return !(business && orgName);
    });
    const methods = {
      open() {
        innerShow.value = true;
        surveyInfo.business = '';
        surveyInfo.orgName = '';
        surveyInfo.role = '';
        surveyInfo.scale = '';
        reporter.report('manager_new_guide', {
          message_show: 'show',
        });
      },
      close() {
        innerShow.value = false;
      },
      openModal() {
        sheetTitle.value = i18n_t('企业名称');
        showEditModal.value = true;
        eidtTitle.value = i18n_t('企业名称');
        rules.value = [
          {
            required: true,
            message: i18n_t('请输入内容'),
          },
          {
            validator: (val: string) => val.length <= 24,
            message: i18n_t('字数不得超过24字'),
            type: 'error',
          },
          {
            whitespace: true,
            message: i18n_t('值不能为空'),
          },
        ];
      },
      onConfrim(val: string) {
        switch (sheetTitle.value) {
          case i18n_t('企业名称'):
            surveyInfo.orgName = val;
            break;
          case i18n_t('所属行业'):
            surveyInfo.business = val;
            this.toAddOptions(val, 'business');
            break;
          case i18n_t('您的职位'):
            surveyInfo.role = val;
            this.toAddOptions(val, 'position');
            break;
          case i18n_t('团队规模'):
            surveyInfo.scale = val;
            break;
          default:
            break;
        }
      },
      toSelect(type: number) {
        showSelectSheet.value = true;
        rules.value = [
          {
            required: true,
            message: i18n_t('请输入内容'),
          },
          {
            validator: (val: string) => val.length <= 15,
            message: i18n_t('字数不得超过15字'),
            type: 'error',
          },
          {
            whitespace: true,
            message: i18n_t('值不能为空'),
          },
        ];
        switch (type) {
          case 1:
            sheetTitle.value = i18n_t('所属行业');
            options.value = businessOpitons.value;
            currSelectValue.value = surveyInfo.business;
            break;
          case 2:
            sheetTitle.value = i18n_t('您的职位');
            options.value = positionOptions.value;
            currSelectValue.value = surveyInfo.role;
            break;
          case 3:
            sheetTitle.value = i18n_t('团队规模');
            options.value = SCALE_OPTIONS;
            currSelectValue.value = surveyInfo.scale;
            break;
          default:
            break;
        }
      },
      customAdd() {
        showEditModal.value = true;
        eidtTitle.value = i18n_t('自定义');
      },
      onChange(val: string) {
        showSelectSheet.value = false;
        switch (sheetTitle.value) {
          case i18n_t('所属行业'):
            surveyInfo.business = val;
            break;
          case i18n_t('您的职位'):
            surveyInfo.role = val;
            break;
          case i18n_t('团队规模'):
            surveyInfo.scale = val;
            break;
        }
      },
      toAddOptions(val: string, type: 'business' | 'position') {
        if (type === 'business') {
          const flag = businessOpitons.value.some(item => item.value === val);
          if (!flag) {
            businessOpitons.value.push({
              label: val,
              value: val,
            });
            options.value = businessOpitons.value;
            return;
          }
          tips.error(i18n_t('该行业已存在'));
        }
        if (type === 'position') {
          const flag = positionOptions.value.some(item => item.value === val);
          if (!flag) {
            positionOptions.value.push({
              label: val,
              value: val,
            });
            options.value = positionOptions.value;
            return;
          }
          tips.error(i18n_t('该职位已存在'));
        }
      },
      async confrimGet() {
        innerShow.value = false;
        try {
          await smh.userAPI.createSurvey({
            type: 'create-industry-info',
            data: {
              ...surveyInfo,
            },
            addFlag: true, // 用于标识用户是否需要赠送5G
          });

          reporter.report('manager_new_guide', {
            industry: surveyInfo.business,
            company_name: surveyInfo.orgName,
            position: surveyInfo.role,
            scale: surveyInfo.scale,
          });
          ipc.emit(ipc.RENDERER_EVENTS_MAP.SHOW_USER_SURVEY_RESULT);
        } catch (e) {
          tips.error(e as MsgError);
        }
      },
    };
    onMounted(() => {
      ipc.on(ipc.RENDERER_EVENTS_MAP.START_MOBILE_USER_SURVEY, methods.open);
    });
    onUnmounted(() => {
      ipc.off(ipc.RENDERER_EVENTS_MAP.START_MOBILE_USER_SURVEY, methods.open);
    });
    return {
      canSubmit,
      businessOpitons,
      rules,
      currSelectValue,
      showCustomAdd,
      surveyInfo,
      eidtTitle,
      options,
      showSelectSheet,
      sheetTitle,
      innerShow,
      showEditModal,
      ...methods,
    };
  },
});
